import { Action } from '@ngrx/store';
import { TFactoryListInfoActionType } from './factory-list.models';
import {
  TRESPONSE_GET_FACTORY_UOM,
  TRESPONSE_FACTORY_LIST,
  TREQUEST_ALLOCATE_PRODUCTS_TYPES_TO_FACTORIES,
  TREQUEST_UPDATE_FACTORY_UOM,
  TRESPONSE_UPDATE_FACTORY_UOM,
} from '@monorepo/types';

export class GetFactoryListInfo implements Action {
  readonly type = TFactoryListInfoActionType.GetFactoryList;
}

export class GetFactoryListInfoSuccess implements Action {
  readonly type = TFactoryListInfoActionType.GetFactoryListSuccess;
  constructor(public factoryListRes: TRESPONSE_FACTORY_LIST) {}
}

export class GetFactoryListInfoFailure implements Action {
  readonly type = TFactoryListInfoActionType.GetFactoryListFailure;
}

export class AllocateProductTypesToFactories implements Action {
  readonly type = TFactoryListInfoActionType.AllocateProductTypesToFactories;
  constructor(public productTypesAndFactoryIds: TREQUEST_ALLOCATE_PRODUCTS_TYPES_TO_FACTORIES) {}
}

export class AllocateProductTypesToFactoriesSuccess implements Action {
  readonly type = TFactoryListInfoActionType.AllocateProductTypesToFactoriesSuccess;
}

export class AllocateProductTypesToFactoriesFailure implements Action {
  readonly type = TFactoryListInfoActionType.AllocateProductTypesToFactoriesFailure;
}
export class GetFactoryUom implements Action {
  readonly type = TFactoryListInfoActionType.GetFactoryUom;
  constructor(public factoryId: string) {}
}

export class GetFactoryUomSuccess implements Action {
  readonly type = TFactoryListInfoActionType.GetFactoryUomSuccess;
  constructor(public factoryUom: TRESPONSE_GET_FACTORY_UOM) {}
}

export class UpdateFactoryUom implements Action {
  readonly type = TFactoryListInfoActionType.UpdateFactoryUom;
  constructor(public factoryId: string, public payload: TREQUEST_UPDATE_FACTORY_UOM) {}
}

export class UpdateFactoryUomSuccess implements Action {
  readonly type = TFactoryListInfoActionType.UpdateFactoryUomSuccess;
  constructor(public message: TRESPONSE_UPDATE_FACTORY_UOM) {}
}

export type TFactoryListActions =
  | GetFactoryListInfo
  | GetFactoryListInfoSuccess
  | GetFactoryListInfoFailure
  | AllocateProductTypesToFactories
  | AllocateProductTypesToFactoriesSuccess
  | AllocateProductTypesToFactoriesFailure
  | GetFactoryUom
  | GetFactoryUomSuccess
  | UpdateFactoryUom
  | UpdateFactoryUomSuccess;
